module.exports = __webpack_public_path__ + "img/Analytics.9fca00d2.png";